import React from 'react';
import { useMobile } from 'frontend/src/hooks/useMobile';
import { is8DataApp } from '../../utils';
import Header from '../misc/Header';
import Notifications from './Notifications/Notifications';
import Journey from './Journey/Journey';
import Analytics from './Analytics/Analytics';
import Requests from './Requests/Requests';
import Grid from '@material-ui/core/Grid';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  topGrid: {
    maxWidth: 1280,
    marginRight: 'auto',
    marginLeft: 'auto',
  },
  notFirstGrid: {
    marginTop: ({ isMobile }: any) =>
      isMobile ? theme.spacing(3) : theme.spacing(4.5),
  },
  topGridItem: {
    marginTop: theme.spacing(3),
    position: 'relative',
  },
}));

export default function Layout(props) {
  const isMobile = useMobile();
  const classes = useStyles({ isMobile });
  const {
    notifications,
    journey,
    company,
    requests,
    setRequests,
    rejectNotifications,
    setRejectNotifications,
  } = props;

  if (is8DataApp()) {
    return <Analytics />;
  }

  return (
    <Grid container>
      <Header header="Demand Console" />
      <Grid
        item
        container
        alignItems="stretch"
        justifyContent="center"
        direction="row"
        className={classes.topGrid}
      >
        <Grid item xs={12} sm={6} className={classes.topGridItem}>
          <Notifications
            notifications={notifications}
            rejectNotifications={rejectNotifications}
            setRejectNotifications={setRejectNotifications}
          />
        </Grid>
        <Grid item xs={12} sm={6} className={classes.topGridItem}>
          <Requests requests={requests} setRequests={setRequests} />
        </Grid>
      </Grid>
      <Grid
        item
        container
        alignItems="center"
        justifyContent="center"
        direction="row"
        className={classes.notFirstGrid}
      >
        <Journey journey={journey} company={company} />
      </Grid>
    </Grid>
  );
}
